import React, { useContext, useLayoutEffect, useState } from 'react';
import { Group, Image, Text } from 'react-konva';

import TransformPoints from '../TransformPoints';
import { WellDetailsStates } from 'business/models/CustomModels';
import { CaptureResultTuningValuesDTO, WellImageDTO } from 'business/models/Models';
import { ImageTuningValues } from 'business/models/ImageTuningModel';
import { useRMSelector } from 'redux/hooks';

import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import { useGetWellImage } from './hooks';
import { EFetchingStatus } from 'enums/EFetchingStatus';
import { ImageSizeDetails } from 'components/well/constants';
import { SizeDetails } from 'components/canvas/constants';
import { ExpDashboardContext } from 'components/main/ExperimentDashboardContext';
export interface wellImagesData {
  wellImage: WellImageDTO;
  tuningValues: ImageTuningValues;
  tunedImage: any;
}

export interface wellData {
  wellNum: number;
  plateNum: number;
  plateID: number;
}

export interface wellImagesFetchedData {
  wellDetails: WellDetailsStates;
  imageData: wellImagesData;
  imageStatus: EFetchingStatus;
}

interface finalImageData {
  image: any;
  imageStatus: EFetchingStatus;
}
interface Props {
  setPixelSize: (val) => void;
  wellDetails: WellDetailsStates;
  imageSizeDetails?: ImageSizeDetails;
  selectedWell?: WellDetailsStates;
  isMultipleDropsRoute?: boolean;
  captureResultTuningValues: CaptureResultTuningValuesDTO;
  updateWellsImagesSizeDetails?: (val: ImageSizeDetails) => void;
  setBestFLImageTypeName: (val: string) => void;
  setTpObject: (val: TransformPoints) => void;
  tpObject: TransformPoints;
  sizeDetails: SizeDetails;
  setImageLoaded: (val: boolean) => void;
  params: any;
  isTraversingVertical?: boolean;
}

export const EFetchingStatusText = {
  [EFetchingStatus.InProgress]: 'Loading Image',
  [EFetchingStatus.NotAvailable]: 'No Image Found',
  [EFetchingStatus.Error]: 'Failed to Load Image',
};

let widthRatio = 1;
let heightRatio = 1;

const WellImage = (props: Props) => {
  const {
    params,
    tpObject,
    sizeDetails,
    setPixelSize,
    setBestFLImageTypeName,
    setTpObject,
    imageSizeDetails = undefined,
    selectedWell = undefined,
    isTraversingVertical = false,
    updateWellsImagesSizeDetails,
  } = props;
  const { wellDetails } = props;
  const exp = useRMSelector(selectExp);
  const [wellImage, setWellImage] = useState<WellImageDTO>(null);
  const [tunedImage, setTunedImage] = useState<finalImageData>();
  const expDashboardContext = useContext(ExpDashboardContext);
  const {
    dropImageHorizontalPrefetchingCount,
    dropImageVerticalPrefetchingCount,
    navigatorVerticalPrefetchingCount,
    navigatorHorizontalPrefetchingCount,
  } = expDashboardContext;
  const currentWellMeta = useGetWellImage(
    exp,
    params,
    wellDetails,
    setWellImage,
    setTunedImage,
    setBestFLImageTypeName,
    isTraversingVertical,
    dropImageVerticalPrefetchingCount,
    dropImageHorizontalPrefetchingCount,
    navigatorVerticalPrefetchingCount,
    navigatorHorizontalPrefetchingCount,
  );
  // const dispatch = useRMDispatch();
  // const setDropImagePixelSize = useCallback(
  //   (val: number) => dispatch(setImagePixelSize(val)),
  //   [dispatch],
  // );
  // const lowerLimit = useRMSelector((state) => selectLowerLevelLimit(state));
  // const upperLimit = useRMSelector((state) => selectUpperLevelLimit(state));
  // const autoLowerLimit = useRMSelector((state) => selectAutoLevelLowerLimit(state));
  // const autoUpperLimit = useRMSelector((state) => selectAutoLevelUpperLimit(state));
  // const autoLevelingModeOn = useRMSelector((state) => selectAutoLevelingModeOn(state));
  // const dropImage = useRMSelector(selectDropImage);
  // const [showFrapGraph, setShowFrapGraph] = useShowFrapGraph();
  // const [image, setImage] = useState<HTMLImageElement>();
  // const _setDropImageUrl = useCallback(
  //   (url: string) => {
  //     dispatch(setDropImageUrl(url));
  //   },
  //   [dispatch],
  // );
  // const isCompareTab = window.location.pathname.includes('/compare');
  // const showOverride = useShowOverrideTuning();

  // const isSelectedImage = () => {
  //   return isEqual(selectedWell, wellDetails);
  // };

  // useEffect(() => {
  //   if (
  //     lowerLimit !== undefined &&
  //     upperLimit !== undefined &&
  //     image !== undefined &&
  //     (isSelectedImage() || !isMultipleDropsRoute) &&
  //     wellImage
  //   ) {
  //     const img = new window.Image();
  //     if (wellImage.wellImage) {
  //       img.src = wellImage.wellImage;
  //       img.onload = () => {
  //         const tunedImage: HTMLImageElement | { r: number; g: number; b: number } =
  //           getTunedImageForDrop(
  //             img,
  //             autoLevelingModeOn,
  //             autoLowerLimit,
  //             autoUpperLimit,
  //             lowerLimit,
  //             upperLimit,
  //           );
  //         const imageTuningValues: ImageTuningValues = {
  //           lowerLevelLimit: lowerLimit,
  //           upperLevelLimit: upperLimit,
  //           autoLevelingLowerLimit: autoLowerLimit,
  //           autoLevelingUpperLimit: autoUpperLimit,
  //           isAutoLevelingOn: autoLevelingModeOn,
  //         };
  //         setTunedImage({ image: tunedImage, imageStatus: EFetchingStatus.InProgress });
  //         if (showOverride) {
  //           replaceTunedImageInCache(wellDetails, imageTuningValues, tunedImage);
  //         }
  //       };

  //       img.onerror = () => {
  //         setTunedImage({ image: null, imageStatus: EFetchingStatus.Error });
  //       };
  //     } else {
  //       setTunedImage({ image: null, imageStatus: EFetchingStatus.NotAvailable });
  //     }
  //   }
  // }, [
  //   lowerLimit,
  //   upperLimit,
  //   autoUpperLimit,
  //   autoLowerLimit,
  //   autoLevelingModeOn,
  //   showOverride,
  // ]);

  // const applyTunedImage = (img, captureResultTuningValuesDto) => {
  //   const tuningWindowVM = getTuningWindowForDrop(
  //     exp.experimentTuningValues,
  //     img,
  //     wellDetails.cpID,
  //     captureResultTuningValuesDto,
  //     false,
  //   );

  //   if (
  //     tuningWindowVM == undefined ||
  //     tuningWindowVM.lowerLevelLimit == undefined ||
  //     tuningWindowVM.upperLevelLimit == undefined
  //   ) {
  //     return img;
  //   }

  //   if (isSelectedImage() || !isMultipleDropsRoute) {
  //     const updatedTuningValues = getUpdatedImageTuningValues(
  //       tuningWindowVM,
  //       captureResultTuningValuesDto,
  //     );
  //     dispatch(setImageTuning(updatedTuningValues));
  //   }
  //   const tunedImage = getTunedImageForDrop(
  //     img,
  //     tuningWindowVM.isAutoLevelingOn,
  //     tuningWindowVM.autoLevelingLowerLimit,
  //     tuningWindowVM.autoLevelingUpperLimit,
  //     tuningWindowVM.lowerLevelLimit,
  //     tuningWindowVM.upperLevelLimit,
  //   );
  //   setTunedImage({ image: tunedImage, imageStatus: EFetchingStatus.Loaded });
  // };

  if (imageSizeDetails && Object.keys(currentWellMeta).length > 0) {
    widthRatio =
      currentWellMeta.width && imageSizeDetails.width
        ? currentWellMeta.width / imageSizeDetails.width
        : 1;
    heightRatio =
      currentWellMeta.height && imageSizeDetails.height
        ? currentWellMeta.height / imageSizeDetails.height
        : 1;
  }

  useLayoutEffect(() => {
    if (!wellImage) {
      return;
    }
    setPixelSize(currentWellMeta?.pixelSize);

    const localTpObject = new TransformPoints(
      wellImage.width,
      wellImage.height,
      currentWellMeta.width || wellImage.width,
      currentWellMeta.height || wellImage.height,
      sizeDetails.canvasWidth * widthRatio,
      sizeDetails.canvasHeight * heightRatio,
    );
    localTpObject.leftMargin = (sizeDetails.canvasWidth - localTpObject.scalingWidth) / 2;
    localTpObject.topMargin =
      (sizeDetails.canvasHeight - localTpObject.scalingHeight) / 2;
    setTpObject(localTpObject);
    if (updateWellsImagesSizeDetails) {
      updateWellsImagesSizeDetails({
        width: currentWellMeta.width,
        height: currentWellMeta.height,
        wellDetails,
        scalingWidth: localTpObject.scalingWidth,
        scalingHeight: localTpObject.scalingHeight,
      });
    }
  }, [sizeDetails, widthRatio, heightRatio, selectedWell, currentWellMeta, wellImage]);

  // const fetchImageAndUpdateData = async () => {
  //   if (wellImage === null || !wellImage.isImageAvailable) {
  //     setImage(null);
  //     document.body.style.cursor = 'default';
  //     return null;
  //   }
  //   const url = wellImage.wellImage;
  //   if (!isCompareTab || isSelectedImage()) {
  //     _setDropImageUrl(url);
  //   }

  //   const img = new window.Image();
  //   img.src = url;

  //   img.onload = () => {
  //     setImage(img);

  //     setImageDetailsOnLoad(img, wellImage);
  //     setImageLoaded(true);
  //   };
  //   setPixelSize(wellImage.pixelSize);
  //   setDropImagePixelSize(wellImage.pixelSize);
  //   setBestFLImageTypeName(wellImage.bestFlImageName);
  // };

  // useEffect(() => {
  //   fetchImageAndUpdateData();
  //   return () => {
  //     wellImageSizeDetails = wellImageSizeDetails.filter(
  //       (d) => !isCommonWellDetails(d.wellDetails, wellDetails),
  //     );
  //     dispatch(setDropImage({ ...dropImage, imageId: null }));
  //     if (showFrapGraph) {
  //       setShowFrapGraph(false);
  //     }
  //   };
  // }, [wellImage, wellDetails]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     let imgBatchId;
  //     if (!wellDetails) {
  //       return;
  //     } else {
  //       if (!isNullOrUndefined(wellDetails.inspectionSet)) {
  //         const plateInspection = wellDetails.inspectionSet.groupedInspections.find(
  //           (insp) => insp.plateId == wellDetails.plateID,
  //         );
  //         if (plateInspection != undefined) {
  //           imgBatchId = plateInspection.imageBatchId;
  //         }
  //       }
  //     }
  //     const wellService = new WellService();
  //     let focusLevelImage: ImageFocusLevelDTO = null;
  //     if (dropImage.imageId) {
  //       focusLevelImage = await wellService.getSingleFocusLevelImage(
  //         wellDetails.plateID,
  //         wellDetails.wellNum,
  //         imgBatchId,
  //         wellDetails.dropNumber,
  //         wellDetails.cpID,
  //         wellDetails.regionName,
  //         dropImage.imageId,
  //       );
  //       if (focusLevelImage.image === null) {
  //         addImage(GetBlankImageBase64()).then((img: HTMLImageElement) => {
  //           setImage(null);
  //           setTunedImage(null);
  //           setBestFLImageTypeName(dropImage.imageTitle);
  //         });
  //       } else {
  //         addImage(focusLevelImage.image).then((img: HTMLImageElement) => {
  //           setImage(img);
  //           applyTunedImage(img, captureResultTuningValues);
  //           setImageLoaded(true);
  //           setBestFLImageTypeName(dropImage.imageTitle);
  //         });
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [dropImage.imageId]);

  // const setImageDetailsOnLoad = useCallback(
  //   (img, wellImage) => {
  //     let widthRatio = 1;
  //     let heightRatio = 1;
  //     if (maxImageSizeDetails) {
  //       widthRatio = wellImage.width / maxImageSizeDetails.width;
  //       heightRatio = wellImage.height / maxImageSizeDetails.height;
  //     }
  //     const localTpObject = new TransformPoints(
  //       img.width,
  //       img.height,
  //       wellImage.width,
  //       wellImage.height,
  //       sizeDetails.canvasWidth * widthRatio,
  //       sizeDetails.canvasHeight * heightRatio,
  //     );
  //     localTpObject.leftMargin =
  //       (sizeDetails.canvasWidth - localTpObject.scalingWidth) / 2;
  //     localTpObject.topMargin =
  //       (sizeDetails.canvasHeight - localTpObject.scalingHeight) / 2;
  //     if (updateWellsImagesSizeDetails) {
  //       updateWellsImagesSizeDetails({
  //         width: wellImage.width,
  //         height: wellImage.height,
  //         wellDetails,
  //         scalingWidth: localTpObject.scalingWidth,
  //         scalingHeight: localTpObject.scalingHeight,
  //       });
  //     }
  //     wellImageSizeDetails.push({
  //       imgWidth: img.width,
  //       imgHeight: img.height,
  //       wellImageWidth: wellImage.width,
  //       wellImageHeight: wellImage.height,
  //       wellDetails,
  //     });
  //     setTpObject(localTpObject);
  //   },
  //   [
  //     maxImageSizeDetails,
  //     sizeDetails,
  //     wellDetails,
  //     wellImageSizeDetails,
  //     updateWellsImagesSizeDetails,
  //     WellImage,
  //   ],
  // );

  return (
    <Group id="wellimage-group-container">
      {!tunedImage?.image && (
        <Text
          id="wellimage-group-status-text"
          x={0}
          y={0}
          width={sizeDetails.canvasWidth}
          height={sizeDetails.canvasHeight}
          fontSize={15}
          textAnchor="middle"
          text={
            EFetchingStatusText[
              (tunedImage?.imageStatus as EFetchingStatus) || EFetchingStatus.NotAvailable
            ]
          }
          align="center"
          verticalAlign="middle"
          wrap="none"
          fill="black"
        />
      )}
      <Image
        id="wellimage-group-image"
        height={tpObject ? tpObject.scalingHeight : 400}
        width={tpObject ? tpObject.scalingWidth : 600}
        image={tunedImage?.image as CanvasImageSource}
        x={tpObject ? tpObject.leftMargin : 10}
        y={tpObject ? tpObject.topMargin : 10}
      />
    </Group>
  );
};
export default WellImage;
